<template>
	<search-list v-show="is_show_list" ref="sl" :pageSizes="[25,30,40]" apiPath="/user/list" :where="where" :searchKeys="searchKeys">
		<mm-lc title="Status">
			<mm-adv-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Group">
			<mm-group v-model="where.group_id" multiple/>
		</mm-lc>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="createUser"></el-button>
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res"  >
			<el-table-column label="Id" prop="user_id" />
			<el-table-column label="User name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.user_name" :row_id="sp.row.user_id" row_type="user" />
			</el-table-column>
			<el-table-column label="Email" prop="email"/>
			<el-table-column label="Group" prop="group_name" />
			<el-table-column label="Remark" prop="remark" />
			<el-table-column label="status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="archived(sp.row)">Move To Trash(Archived)</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_list = (user_info.group_name === 'admin');
		const searchKeys = {
			user_name: { label: "User Name", fuzzy: true },
			user_id: { label: "User Id" }
		};
		return {
			searchKeys,
			where: {},
			is_show_list,
		};
	},
	methods: {
		createUser() {
			window.open('/userCreate');
		},
		edit(row){
			window.open('/userEdit?id='+row.user_id);
		},
		async archived(row){
            await this.$post('user/archived',{user_id:row.user_id});
            this.$refs.sl.refresh();
		},
		getDetail(adv_id) {
			this.rootGetDetail(adv_id,true);
		}
	},
	inject: ['rootGetDetail'],

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
